/* eslint-disable compat/compat */

export default (function () {
  return {
    init() {

      let lazyloadImages;

      if ('IntersectionObserver' in window) {
        lazyloadImages = document.querySelectorAll('.js-lazy');
        spirax.lazyImages.observer(lazyloadImages);
      } else {
        lazyloadImages = document.querySelectorAll('.js-lazy');
        spirax.lazyImages.unsetLazyImages(lazyloadImages);
      }
    },
    observer(images) {
      const imageObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const image = entry.target;
            image.src = image.dataset.src;
            image.classList.remove('js-lazy');
            imageObserver.unobserve(image);
          }
        });
      });

      images.forEach((image) => {
        imageObserver.observe(image);
      });
    },
    unsetLazyImages(images) {
      if (images.length > 0) {
        images.forEach((img) => {
          img.src = img.dataset.src;
          img.classList.remove('js-lazy');
        });
      }
    },
  };
}());
